import React from 'react';
import {
  TextField as MuiTextField,
  TextFieldProps,
  Box,
  Typography,
  styled,
} from '@mui/material';
import { inputBaseStyles, helperTextStyles, requiredAsteriskStyles } from '../../styles/inputStyles';

interface InputFieldProps extends Omit<TextFieldProps, 'variant'> {
  label?: string;
  helperText?: string;
  width?: string | number;
  optional?: boolean;
}

const StyledTextField = styled(MuiTextField)(() => ({
  ...inputBaseStyles,
  ...requiredAsteriskStyles,
}));

const HelperText = styled(Typography)(() => ({
  ...helperTextStyles,
}));

const TextField: React.FC<InputFieldProps> = ({
  label,
  helperText,
  width,
  optional = false,
  required = false,
  id,
  name,
  ...props
}) => {
  const inputId = id ?? name;
  return (
    <Box>
      {label && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography
            component="label"
            htmlFor={inputId}
            className="input-field-label"
          >
            {label}
            {required && <span>*</span>}
          </Typography>
        </Box>
      )}
      <StyledTextField
        variant="outlined"
        required={required}
        sx={{ width: width || '100%' }}
        {...props}
        id={inputId}
        name={name}
      />
      {helperText && <HelperText>{helperText}</HelperText>}
    </Box>
  );
};

export default TextField;